import {
  FILL_POLLY_CONFIG_LIST,
} from './mutations-types';

export default {
  [FILL_POLLY_CONFIG_LIST](state, payload) {
    const _state = state;
    _state.pollyConfigList.records = payload.records || [];
    _state.pollyConfigList.total = payload.total || 0;
  },
};
